import React from 'react';

import type { ButtonProps } from '@sravni/react-design-system/dist/types/components/Button';

import { OptimizedPicture } from '@src/components/ui/OptimizedPicture';
import { PromoInfoBox } from 'entities/Promo/ui/PromoInfoBox/PromoInfoBox';
import { ToFullDealAdvertisingButton } from 'features/FullDeal';
import { SRAVNI_LOGO_URL } from 'shared/config/logoUrl';

interface Props {
  link: string;
  buttonColor?: ButtonProps['color'];

  source: string;
}

export const PromoDealRedirectToAppButton = ({ link, buttonColor, source }: Props) => (
  <PromoInfoBox>
    <ToFullDealAdvertisingButton
      style={{ width: '100%' }}
      block
      variant="primary"
      link={link}
      color={buttonColor}
      source={source}
    >
      <>
        <OptimizedPicture img={SRAVNI_LOGO_URL} alt="logo" width={15} height={13} />
        Получить займ в приложении
      </>
    </ToFullDealAdvertisingButton>
  </PromoInfoBox>
);
